
import {protoUI} from "../ui/core";
import template from "../views/template";

protoUI({ name:"multicombo", defaults:{
	template:"GPL version doesn't support multicombo <br> You need Webix PRO"
}}, template.view);